import { ReactiveVar, makeVar } from '@apollo/client'

import { IChartRow, IChartLookup } from 'shared/interfaces'

export const ChartsStore = {
  chartsList: {
    read: () => chartsListVar()
  },
  factSourcesList: {
    read: () => factSourcesListVar()
  }
}

export const chartsListVar: ReactiveVar<IChartRow[]> = makeVar<IChartRow[]>([])
export const factSourcesListVar: ReactiveVar<IChartLookup[]> = makeVar<IChartLookup[]>([])
